import React from "react";
import PropTypes from "prop-types";

import styles from "./checkbox.module.scss";

export default function Checkbox(props) {
  const { label, invalidFeedback, idSuffix, checked, onChange } = props;

  return (
    <label
      htmlFor={`customControlValidation${idSuffix}`}
      className={`custom-control custom-checkbox d-flex align-items-center ${styles.checkbox}`}
    >
      <input
        type="checkbox"
        className={`custom-control-input ${styles["checkbox-input"]}`}
        id={`customControlValidation${idSuffix}`}
        required
        checked={checked}
        onChange={e => onChange(e)}
      />
      <span className={`custom-control-label ${styles["checkbox-label"]}`}>
        {label}
      </span>
      <div className="invalid-feedback">{invalidFeedback}</div>
    </label>
  );
}

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  invalidFeedback: PropTypes.string,
  idSuffix: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

Checkbox.defaultProps = {
  invalidFeedback: ""
};
